import { render, staticRenderFns } from "./add-profil_pembelajaran.vue?vue&type=template&id=1cd71a54&"
import script from "./add-profil_pembelajaran.vue?vue&type=script&lang=js&"
export * from "./add-profil_pembelajaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports